export default __webpack_public_path__ + "static/media/exp-img3.0d433710.svg";